import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from './_services/security/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Gradient Able 5+';

  timeout = 30000;

  constructor(private router: Router,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  //  this.maintenancecheck();
  }

  maintenancecheck() {
    
    var timeoutHandle = setInterval(() => {
      this.authenticationService.isundergoingmaintenance().subscribe(r => {
        if (r) {
          this.authenticationService.logout();
          this.router.navigate(["auth/maintenance"]);
          window.clearTimeout(timeoutHandle);
        } else {
          //this.timeout = 60000;
        // this.maintenancecheck();
        // this.router.navigate(["auth/login"]);

        }
      });
    }, this.timeout);
  }
}
